module.exports = __webpack_public_path__ + "static/navigation_menu-49a639c8b06faef12d6ee70c9485e30c.png";